import type { TableRowType } from '../components/editor/grid/reduxStore/table.types';
import { TotalRowTypesIdentifier } from '../components/editor/grid/reduxStore/table.types';
import { TableRowDefaultClassNamesEnum } from '../components/editor/grid/reduxStore/tableRowDefaultStyleSlice.ts';

export const isRowBelongsToTotal = (row) => Object.values(TotalRowTypesIdentifier).includes(row.rowType);

// Position of each Body row among Body rows only, so header rows never shift which rows alternate.
export const getBodyRowIndexById = (rows: Pick<TableRowType, 'id' | 'rowType'>[]) =>
  new Map(rows.filter((row) => row.rowType === 'Body').map((row, index) => [row.id, index]));

export const getRowClassName = (
  rowType: string,
  isGrouped?: boolean,
  isLightBackground?: boolean,
  isUnrelatedFallback?: boolean,
  rowIndex?: number
) => {
  const key = (rowType ?? '').toUpperCase();
  const baseClass = TableRowDefaultClassNamesEnum[key as keyof typeof TableRowDefaultClassNamesEnum] || '';
  const altClass = key === 'BODY' && rowIndex !== undefined && rowIndex % 2 === 1 ? 'py-alt-row' : '';
  if (!isGrouped) return [baseClass, altClass].filter(Boolean).join(' ');

  const groupClassesByBackground = isUnrelatedFallback
    ? { light: 'py-group-row-fallback-light', dark: 'py-group-row-fallback-dark' }
    : { light: 'py-group-row-light', dark: 'py-group-row-dark' };
  const groupClass = isLightBackground ? groupClassesByBackground.light : groupClassesByBackground.dark;

  return [baseClass, altClass, groupClass].filter(Boolean).join(' ');
};

export const isTaxOrDiscountRow = (row: TableRowType) =>
  row.rowType === TotalRowTypesIdentifier.TAX || row.rowType === TotalRowTypesIdentifier.DISCOUNT;

export const getRowAttributeName = (row: TableRowType): string => {
  const rowType = isTaxOrDiscountRow(row) ? TotalRowTypesIdentifier.SUBTOTAL : row.rowType;
  return `table_${rowType.toLowerCase()}_row`;
};
